import * as ReactDOM from 'react-dom';
import React from 'react';
import Logos from './components/logos';
var rootElement = document.getElementById('logos-react');
var localizationCode = rootElement.dataset.localizationCode;
delete rootElement.dataset.localizationCode;
ReactDOM.render(React.createElement(Logos, { localizationCode: localizationCode }), rootElement);
